import ClinicDetailsModalImage from '../../assets/icons/fbs/ClinicImage.png';
import LocationIcon1 from '../../assets/icons/fbs/LocationIcon1.svg';
import StarIcon1 from '../../assets/icons/fbs/StarIcon1.svg';
import CloseIcon from '../../assets/icons/fbs/CloseIcon.svg';
import { ScanCenter } from '../../api/scans';

type ClinicDetailsModalProps = {
    clinic: ScanCenter | null;
    handleCloseClinicDetails: () => void;
};

function renderStars(count: number) {
    return Array.from({ length: count }, (_, i) => (
        <img key={i} src={StarIcon1} alt="Rating" />
    ));
}

const ClinicDetailsModal = ({ clinic, handleCloseClinicDetails }: ClinicDetailsModalProps) => {
    if (!clinic) return null;

    const clinicDisplayName = (clinic as any).full_body_name || clinic.name;
    const clinicDisplayDescription = (clinic as any).full_body_description || clinic.description;

    const rating = clinic.avg_rating ? parseFloat(clinic.avg_rating) : null;
    const distanceText = clinic.distance != null
        ? `${clinic.distance % 1 === 0 ? clinic.distance : clinic.distance.toFixed(1)} mile${clinic.distance !== 1 ? 's' : ''} away`
        : '';
    const address = clinic.address_without_name || `${clinic.street}, ${clinic.postcode}`;
    const images = clinic.images && clinic.images.length > 0 ? clinic.images : [clinic.image || ClinicDetailsModalImage];
    const mainImage = images[0];

    return (
        <div className='clinic-details-modal' >
            <div className="clinic-details-modal-overlay" >
                <div className="clinic-details-modal-content" >
                    <div className='clinic-details-modal-content-header' >
                        <div>
                            <h2>{clinicDisplayName}</h2>
                            <div>Address: {address}</div>
                        </div>
                        <button onClick={handleCloseClinicDetails} className='close-button' >
                            <img src={CloseIcon} alt="Close" />
                        </button>
                    </div>
                    <div className='clinic-tags-wrapper' >
                        {/* Speak to us (hidden for now - per Figma update) */}
                        {distanceText && <div className='clinic-tag' ><img src={LocationIcon1} alt="Location" />{distanceText}</div>}
                        {rating != null && !isNaN(rating) && (
                            <div className='clinic-tag' >{rating.toFixed(1)}
                                <div className='star-icon-wrapper' >
                                    {renderStars(Math.round(rating))}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="modal-row" >
                        <div className="modal-column-left" >
                        {clinicDisplayDescription || 'This centre provides diagnostic imaging services, offering accessible and affordable private MRI scans with no compromise on quality.'}
                        </div>
                        <div className="modal-column-right" >
                            <div>
                                <img src={mainImage} alt="Clinic" />
                            </div>
                            {images.length > 1 && (
                                <div className='image-thumbnail' >
                                    {images.slice(0, 3).map((img, i) => (
                                        <button key={i} className='image-thumbnail-btn' ><img src={img} alt={`Clinic ${i + 1}`} /></button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClinicDetailsModal;
